import LoginForm from './LoginForm';

const Login = () => {
  return (
    <main className="min-h-screen w-full bg-gradient-to-b from-[#000000] to-[#E8BF21] flex items-center justify-center p-4">
      <div className="w-full max-w-md flex flex-col items-center justify-center h-screen space-y-4 sm:space-y-6 md:space-y-8">
        {/* Logo - Responsive sizing */}
        <div className="w-full flex justify-center flex-shrink-0">
          <img
            src="/logoWhite.png"
            alt="Av Work Force"
            className="
              w-40 h-auto object-contain
              sm:w-48
              md:w-56
              lg:w-64
              xl:w-72
              max-h-[20vh]
            "
            draggable={false}
          />
        </div>

        {/* Login Form - Responsive sizing and scrollable */}
        <div
          className="
          w-full bg-white rounded-xl shadow-2xl
          p-4 sm:p-6 md:p-8
          max-h-[70vh] overflow-y-auto
          flex-shrink-0
        "
        >
          <LoginForm />
        </div>
      </div>
    </main>
  );
};

export default Login;
